const persianNumbers: Array<string> = ["۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹", "۰"],
	englishNumbers: Array<string> = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];

/**
 * Used for convert Persian numbers to English
 *
 * @api private
 * @method persianNumber
 * @param {Any} value
 * @return {String} value
 */
export function persianNumber(value: any) {
	if (!value) {
		return "";
	}

	for (let i = 0, numbersLen = englishNumbers.length; i < numbersLen; i++) {
		value = value.toString().replace(new RegExp(persianNumbers[i], "g"), englishNumbers[i]);
	}

	return value;
}

/**
 * Normalize numbers value to form component
 *
 * @param {Any} value
 * @param {Any} prevValue
 */
export function normalizeNumbers(value: any, prevValue: any) {
	return persianNumber(value);
}
